import $ from 'jquery';
import BasePropertyView from 'BasePropertyView';
import listService from 'ListService';
import constants from 'Constants';
import _template from 'behaviors/properties/main/connector.ejs';
import widgetUtil from 'util/WidgetUtil';


class ConnectorView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #lineType' : 'updateAttributes'
        };

        return this;
    }


    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        // PF-2345 capture linetype, translating template value to model value
        if (propName === 'lineType') {
            widgetUtil.removeAllBezeierControlPoints();
            listService.currentSelectedPathId = undefined;
            const pathShapeModel = {'straight': 'straight', 'curved': 'bezier'}[propVal];
            this.model.set(propName, pathShapeModel, constants.ACCESS_SILENT);
        }
        else if (propName === 'textBoxWidth') {
            let val = parseInt(propVal);
            if (val < 0 || isNaN(val)) {
                this.model.set(propName, '0', constants.ACCESS_SILENT);
            }else if (propVal.length < 4) {
                this.model.set(propName, propVal, constants.ACCESS_SILENT);
            } else {
                this.model.set(propName, propVal.substring(0, 3), constants.ACCESS_SILENT);
            }
        }
        else {
            this.model.set(propName, propVal);
        }
        this.render();
        // Render twice to eliminate phantoms
        listService.fcanvas.renderAll();
        listService.fcanvas.renderAll();
    }


    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        // PF-2345 render linetype property, translating model value to template UI value
        if(this.model.has('lineType')) {
            const pathShapeUI = { 'straight': 'straight', 'bezier': 'curved'}[this.model.get('lineType')];
            $('#lineType').find(`option[value=${pathShapeUI}]`).attr('selected', true);
        }
        
        this.delegateEvents();
        return this;
    }

}

export default ConnectorView;
